//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfModal from "~/themes/fiskarsMoominDefault/components/components/molecules/SfModal/SfModal.vue";
import SfCheckbox from "~/themes/fiskarsMoominDefault/components/components/molecules/SfCheckbox/SfCheckbox.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import SfHeading from "~/themes/fiskarsMoominDefault/components/components/atoms/SfHeading/SfHeading.vue";
import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import { ref, reactive, computed } from '@nuxtjs/composition-api';
import { useUiState } from '~/composables';
import { validateEmail, validateName, markFieldAsTouched, createField, createToggleField, isFormValidated } from '~/helpers/validation-utils';
import {useVSFContext} from "@vue-storefront/core";
import { COOKIES } from "~/helpers/constants";


export default {
  name: 'NewsletterModal',
  components: {
    SfModal,
    SfHeading,
    SfInput,
    SfButton,
    SfCheckbox,
    SfLoader
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showConfirmation: {
      type: Boolean,
      default: false
    },
    showError: {
      type: Boolean,
      default: false
    },
    titleandtext: Object,
    submitbuttontext: String,
    footersubscribebutton: String,
    buttontext: String,
    title: String,
    subtitle: String,
    firstNameLabel: String,
    lastNameLabel: String,
    emailLabel: String,
    ccmessage: String,
    firstnamevalidation: String,
    lastnamevalidation: String,
    emailvalidation: String,
    ccvalidaitonmessage: String,
    successmessage: String,
    failuremessage: String,
    successmessagetitle: String,
    failuremessagetitle: String,
    tcmessage: [String, Object],
  },
  setup(props, { emit }) {
    const { isNewsletterModalOpen, toggleNewsletterModal } = useUiState();
    const context = useVSFContext();
    const userCookieData = context.$cookies?.get(COOKIES.USER_DATA);
    const firstName = ref("");
    const lastName = ref("");
    const email = ref("");
    const isHidden = ref(true);
    const subscribeNewsletter = ref(false);
    const showThanksModal = ref(false);
    const formValues = reactive({
      firstName: createField(
        userCookieData?.fn ?? "",
        "First name",
        validateName,
        props.firstNameLabel,
        "firstName"
      ),
      lastName: createField(
        userCookieData?.ln ?? "",
        "Last name",
        validateName,
        props.lastNameLabel,
        "lastName"
      ),
      email: createField(
        userCookieData?.e ?? "",
        "Email address",
        validateEmail,
        props.emailLabel
      ),
      termsAndConditions: createToggleField(
        false,
        props.ccmessage,
        props.ccvalidaitonmessage
      )
    })

    const showResponse = computed(() => !props.loading && (props.showError || props.showConfirmation));

    const onCloseModal = () => {
      toggleNewsletterModal();
      resetStatus();
    };

    const emitNewsletterPayload = (newsletterData) => emit('submitForm', newsletterData);

    const handleSubmit = () => {
      // Mark all required fields as touched
      ['firstName', 'lastName', 'email', 'termsAndConditions'].forEach(
        (field) => (formValues[field].touched = true)
      );

      if (!canSubmit.value) return false;

      const newsletterData = {
        firstName: formValues.firstName.value,
        lastName: formValues.lastName.value,
        email: formValues.email.value,
      };

      emitNewsletterPayload(newsletterData);
    };

    const resetStatus = () => {
      // Hide the thank-you modal.
      showThanksModal.value = false;

      // Reset touched flags:
      formValues.firstName.touched = false;
      formValues.lastName.touched = false;
      formValues.email.touched = false;
      formValues.termsAndConditions.touched = false;

      // Reset values:
      formValues.firstName.value = "";
      formValues.lastName.value = "";
      formValues.email.value = "";
      formValues.termsAndConditions.value = false;

      // Reset state for checkbox.
      subscribeNewsletter.value = false;
    };


    //can submit form
    const canSubmit = computed(
      () =>
        !!(
          isFormValidated(formValues) &&
          !props.loading
        )
    );

    return {
      isNewsletterModalOpen,
      toggleNewsletterModal,
      isHidden,
      onCloseModal,
      subscribeNewsletter,
      showThanksModal,
      handleSubmit,
      formValues,
      validateName,
      showResponse,
      markFieldAsTouched,
      firstName,
      lastName,
      email,
      canSubmit
    };
  }
};
